<!-- 缩略图页面 -->
<template>
	<div class="playImg">
		<div class="back" @click="back">
			<img src="@/assets/svg/Impression/back_white.svg">
		</div>
		<div class="topListBox">
			<div class="swiper-container swiper-container9">
				<div class="swiper-wrapper topList">
					<li :class="['swiper-slide',{active: topListActive == index}]"
					v-for="(item,index) in imgs"
					:key="index"
					@click="topListClick(index,1)"
					>
						{{ item.name }}({{item.images.length}})
						<div v-if="index == 0" ref="border"></div>
					</li>
				</div>
			</div>
		</div>
		<div class="addImg" @click="goAddImg">
			<img src="@/assets/svg/mock.svg">
		</div>
		<div class="imgs">
			<div class="swiper-container swiper-container8">
				<div class="swiper-wrapper">
					<li class="swiper-slide"
					v-for="(item,index) in imgsList"
					:key="index"
					>
						<img :src="item.url">
					</li>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Swiper from "swiper";
export default{
	data(){
		return {
			imgsList: [],
			imgs: this.$store.state.wholeData[this.$store.state.indexObj.outside][this.$store.state.indexObj.inside].imgs,
			topListActive: 0,
			swiper: null,
			imgsLenghtArr: [],
			swiper2: null
		}
	},
	created(){
		// console.log(this.imgs);
		this.imgs.forEach((item,index) => {
			this.imgsLenghtArr.push(item.images.length - 1);
			item.images.forEach((value,j) => {
				let obj = {};
				obj.outside = index;
				obj.inside = j;
				obj.url = value;
				this.imgsList.push(obj);
			});
		});
		// console.log(this.imgs[1].images[0]);
	},
	mounted(){
		let swiper = new Swiper('.swiper-container9',{
			slidesPerView: 'auto',
			observer: true,
			observeSlideChildren: true,
		});
		this.swiper2 = swiper;
		let _this = this;
		this.swiper = new Swiper('.swiper-container8',{
			observer: true,
			observeSlideChildren: true,
			on: {
				slideChangeTransitionEnd:function(){
					console.log(_this.imgsList[this.realIndex]);
					let num = _this.topListActive == 0?_this.imgsLenghtArr[_this.imgsLenghtArr.length - 1] : _this.imgsLenghtArr[_this.topListActive - 1];
					let num1 = _this.topListActive == 0? _this.imgsLenghtArr.length - 1 : _this.topListActive - 1;
					if(_this.imgsList[this.realIndex].inside == 0){
						_this.topListClick(_this.imgsList[this.realIndex].outside,0);
						// try{
						// 	_this.swiper2.slideTo(num1,100,false);
						// }catch(e){
						// 	_this.swiper2[1].slideTo(num1,100,false);
						// }
					}else if(_this.imgsList[this.realIndex].inside == num && num1 == _this.imgsList[this.realIndex].outside){
						_this.topListClick(num1,0);
						// try{
						// 	_this.swiper2.slideTo(num1,100,false);
						// }catch(e){
						// 	_this.swiper2[1].slideTo(num1,100,false);
						// }
					}
					console.log(num,_this.imgsList[this.realIndex].inside);
					// for(let i = 0; i < _this.imgsLenghtArr.length; i++){
					// 	if(_this.imgsList[this.realIndex].inside == _this.imgsLenghtArr[i]){
					// 		_this.topListClick(i,0);
					// 		break;
					// 	}
					// };
				},
			}
		});
		if(_this.$store.state.imgIndexObj.outside != 0){
			_this.topListClick(_this.$store.state.imgIndexObj.outside,1);
			
		}else{
			if(_this.$store.state.imgIndexObj.inside != 0){
				try{
					this.swiper.slideTo(_this.$store.state.imgIndexObj.inside,100,false);
				}catch(e){
					this.swiper[1].slideTo(_this.$store.state.imgIndexObj.inside,100,false);
				}
			}
		}
	},
	methods: {
		back(){
			this.$router.push("/details");
		},
		goAddImg(){
			this.$router.push("/addImg");
		},
		topListClick(index,state){
			this.topListActive = index;
			this.$refs.border[0].style.left = this.topListActive * 100 + 50 + "%";// 计算出偏移量
			let imgsListLength = this.imgsList.length;
			if(state){
				for(let i = 0; i < imgsListLength; i++){
					if(this.imgsList[i].outside == index && this.imgsList[i].inside == 0){
						console.log(this.swiper);
						try{
							this.swiper.slideTo(i,100,false);
						}catch(e){
							this.swiper[1].slideTo(i,100,false);
						}
						
					}
				}
			}
			// this.$refs.border[0].style.transition = "all 0.3s ease"; // 执行动画
		},
	},
}
</script>

<style lang="scss" scoped>
	.playImg{
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		background: #000;
		line-height: 1;
		touch-action: none;
		.back{
			width: .24rem;
			height: .4rem;
			position: absolute;
			left: 0;
			top: 0;
			box-sizing: content-box;
			padding: .3rem;
			z-index: 10;
			img{
				transform: rotate(180deg);
			}
		}
		.topListBox{
			width: 100%;
			height: 1rem;
			position: absolute;
			left: 0;
			top: 0;
			padding-left: .8rem;
			padding-right: 1rem;
			.swiper-container{
				width: 100%;
				height: 1rem;
				line-height: 1rem;
				display: flex;
				align-items: center;
				.topList{
					li{
						width: auto;
						padding: 0 .1rem;
						font-size: .28rem;
						color: #fff;
						position: relative;
						&.active{
							color: #0BCFCA;
						}
						>div{
							width: .4rem;
							height: .06rem;
							background: #0BCFCA;
							position: absolute;
							left: 50%;
							transform: translateX(-50%);
							bottom: .2rem;
							transition: all 0.3s ease;
						}
					}
				}
			}
		}
		.addImg{
			width: .4rem;
			height: .4rem;
			position: absolute;
			right: 0;
			top: 0;
			box-sizing: content-box;
			padding: .3rem .3rem 0 0;
			z-index: 10;
		}
		.imgs{
			width: 100%;
			height: 100%;
			position: absolute;
			left: 0;
			top: 0;
			display: flex;
			align-items: center;
			overflow: hidden;
			padding-top: 1rem;
			.swiper-container{
				width: 100%;
				.swiper-wrapper{
					display: flex;
					align-items: center;
				}
			}
		}
	}
</style>
